
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "comment",
directives:{
TransferDom
},
components: {
PopupHeader,
Popup
},
data(){
return{
wrapperHeight:0,
allLoaded:false,
commentList:[],
page:0,
sort:'DESC',
fkType:'ARTICLE',
fkId:null,
commentContent:'',
commentShow:false,
imgBaseUrl:process.env.API_ROOT,
headUrl: require('../../assets/icon/user-header.png')
}
},
methods:{
init: function() {

this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top - 45;
},
loadTop(){
this.page = 0;
let obj = {
direction: "DESC",
fromClientType: "h5",
number: this.page,
property: "createdDate",
size:10,
rules:[
{
field:'fkId',
values:[this.fkId],
option:"IN"
},{
field:'fkType',
values:[this.fkType],
option:"IN"
}
]
};
this.$post('api/comments/page',obj).then((data) => {
if(data.content){
this.commentList = data.content;
}else{
this.commentList = [];
}
this.$refs.loadmore.onTopLoaded();
}).catch(() => {
this.$refs.loadmore.onTopLoaded();
})
},
loadBottom(){
this.page++;
let obj = {
direction: "DESC",
fromClientType: "h5",
number: this.page,
property: "createdDate",
size:10,
rules:[
{
field:'fkId',
values:[this.fkId],
option:"IN"
},{
field:'fkType',
values:[this.fkType],
option:"IN"
}
]
};
this.$post('api/comments/page',obj).then((data) => {
if(data.content){
this.commentList = this.commentList.concat(data.content);
}
this.$refs.loadmore.onBottomLoaded();
}).catch(() => {
this.$refs.loadmore.onBottomLoaded();
})
},
getCommentList(){
let obj = {
direction: "DESC",
fromClientType: "h5",
number: this.page,
property: "createdDate",
size:10,
rules:[
{
field:'fkId',
values:[this.fkId],
option:"IN"
},{
field:'fkType',
values:[this.fkType],
option:"IN"
}
]
};
this.$post('api/comments/page',obj).then((data) => {
console.log(data)
if(data.content){
this.commentList = data.content;
}else{
this.commentList = [];
}
})
},
goComment(){
this.commentShow = true;
},
cancelComment(){
this.commentContent = '';
this.commentShow = false;
},
sureComment(){
if(!this.commentContent){
this.$vux.toast.text('请输入评论内容');
return;
}
let commentObj = {
fkType:this.fkType,
fkId:this.fkId,
content:this.commentContent
};
this.$loadingShow();
this.$post('api/comments',commentObj).then(() => {
this.$vux.toast.text('发送成功');
this.commentContent = '';
this.commentShow = false;
this.$loadingHide();
this.page = 0;
this.getCommentList();
}).catch(() => {
this.$loadingHide();
})
},
deleteComment(item,index){
let that = this;
this.$vux.confirm.show({
title: '确认删除此评论',
onConfirm(){
that.$loadingShow();
that.$del(`api/comments/${item.id}`).then(() => {
that.$loadingHide();
that.commentList.splice(index,1);
that.$vux.toast.text('已删除评论');
}).catch(() => {
that.$loadingHide();
});
}
})

}
},
mounted(){
this.fkId = this.$route.params.id;
this.init();
this.getCommentList();
}
}



// WEBPACK FOOTER //
// ./src/page/home/comment.vue